import React from 'react';
import { Tag } from 'antd';
import {
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons';

interface Props {
    status: string;
}

const PdfExportStatusChip: React.FC<Props> = ({ status }) => {
    switch (status) {
        case 'QUEUED':
            return (
                <Tag icon={<ClockCircleOutlined />} color="default">
                    Queued
                </Tag>
            );
        case 'IN_PROGRESS':
            return (
                <Tag icon={<SyncOutlined spin />} color="processing">
                    In progress
                </Tag>
            );
        case 'SUCCEEDED':
            return (
                <Tag icon={<CheckCircleOutlined />} color="success">
                    Succeeded
                </Tag>
            );
        case 'FAILED':
            return (
                <Tag icon={<CloseCircleOutlined />} color="error">
                    Failed
                </Tag>
            );
        case 'SKIPPED':
            return (
                <Tag icon={<MinusCircleOutlined />} color="default">
                    Skipped
                </Tag>
            );
        default:
            return <Tag color="default">{status}</Tag>;
    }
};

export default PdfExportStatusChip;
